import React, { Fragment } from 'react';
import {Input, Label,Col,Row ,Button} from 'reactstrap';
import {cedimi} from '../../constant/globalConstantsTypeClients'
import { DataView } from "primereact/dataview";



export const TableQuoter = (props) => {
    let url = localStorage.getItem('url_helen')

    const {items, handleCheckUrgent, deleteExamProfile,viewButtons, handleViewExamsProfile,number_format} = props;



    const itemTemplate = (item, index) => 
    {
        let _index = items.indexOf(item);

        return (
            <div key={_index} className="p-2 border-round shadow-2 surface-card mb-2">
                <div className="flex justify-content-between align-items-center mb-1">
                    <Col sm="12">
                        <Row>
                            <Col sm="11">
                                <b
                                    style={{ color: "#000000", fontSize: "14px" }}
                                    className={item?.is_urgent ? "text-danger" : ""}
                                >
                                {"(" + item?.code + ")"}{item?.name ?? "---"} {item?.id_profile !== null && (
                                        <Button
                                            size="xs"
                                            color="primary"
                                            onClick={() => handleViewExamsProfile(item?.id_profile)}
                                        >
                                            <i className="icofont icofont-laboratory"></i>
                                        </Button>
                                    )}
                                </b>
                                <b
                                    className={
                                        item?.is_urgent ? "text-danger font-bold f-12" : "f-12 font-bold" ?? ""
                                    }
                                >
                                </b>
                                <br />
                                <b style={{ fontSize: "15px" }} className={item?.is_urgent ? "text-danger" : ""}>
                                    {item?.config_iva
                                        ? item?.id_agreement === null || item?.id_agreement === 0
                                            ? `$ ${number_format(item?.price.toFixed(2))}`
                                            : `$ ${number_format(item?.price_Agremment.toFixed(2))}`
                                        : item?.id_agreement !== null && item?.id_agreement !== 0
                                            ? `$ ${number_format((item?.price_Agremment * 1.16).toFixed(2))}`
                                            : `$ ${number_format((item?.price * 1.16).toFixed(2))}`}
                                </b>
                                <br />
                                <label className='label-quoter-mic' style={{ color: "#4b5563d1" }}>Tiempo de entrega:{item?.delivery_time ?? "N/A"}</label>
                                <br />
                            </Col>
                            <Col sm="1">
                                <div className="d-flex flex-column justify-content-between h-100 align-items-end">
                                    <div className="d-flex align-items-center justify-content-end mb-2">
                                        <Label 
                                            for={`checkboxP${_index}`} 
                                            className="form-check-label mb-1" 
                                            style={{ marginRight: "25px" }} 
                                        >
                                            {url === cedimi ? "Guardia" : "¿Urgente?"}
                                        </Label>
                                        <Input
                                            type="checkbox"
                                            id={`checkboxP${_index}`}
                                            checked={item?.is_urgent}
                                            onChange={(e) => handleCheckUrgent(_index, e)}
                                            className="form-check-input"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                    {/* {cedimi !== url && (
                                        <div className="d-flex justify-content-end mb-2">
                                            <Input
                                                type="text"
                                                name="percentage"
                                                placeholder="%"
                                                autoComplete="off"
                                                onChange={(e) =>
                                                    handleChangePercentage(e, item.id_exam, item.id_profile)
                                                }
                                                className="form-control form-control-sm input-air-primary"
                                                style={{ width: "70px" }}
                                            />
                                        </div>
                                    )} */}

                                    <div className="d-flex justify-content-end align-items-center mt-auto">
                                        {viewButtons && (
                                            <Button
                                                size="sm"
                                                color="danger"
                                                onClick={(e) => deleteExamProfile(e, item?.id_exam, item?.id_profile)}
                                                style={{
                                                    width: "35px",             
                                                    height: "35px",            
                                                    backgroundColor: "#e74c3c", 
                                                    borderColor: "#e74c3c", 
                                                    borderRadius: "50%",        
                                                    display: "flex",            
                                                    justifyContent: "center",   
                                                    alignItems: "center",       
                                                    padding: "0",              
                                                    boxShadow: "none",        
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = "#c0392b"} 
                                                onMouseLeave={(e) => e.target.style.backgroundColor = "#e74c3c"}  
                                            >
                                                <i className="fa fa-trash-o" style={{ color: "#fff", fontSize: "18px" }}></i> 
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </div>
            </div>
        );
    };

    return (
            <DataView
                value={items}          
                itemTemplate={itemTemplate} 
                layout="list"                          
            />        
    )
}
